import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Container } from 'reactstrap';
import classnames from 'classnames';
import { ClippedContainer } from 'site-modules/shared/components/clipped-container/clipped-container';
import { getImageUrl, SOURCES } from 'client/utils/image-helpers';
import { heroMask } from 'site-modules/shared/components/car-reviews-landing-hero/utils/mask-library/hero-mask';
import {
  heroImageMaskChal3,
  heroImageMaskMobileChal3,
} from 'site-modules/shared/components/car-reviews-landing-hero/utils/mask-library/hero-image-mask';
import {
  heroBackground1MaskChal3,
  heroBackground1MaskMobileChal3,
} from 'site-modules/shared/components/car-reviews-landing-hero/utils/mask-library/hero-background-1-mask';
import {
  heroBackground2MaskChal3,
  heroBackground2MaskMobileChal3,
} from 'site-modules/shared/components/car-reviews-landing-hero/utils/mask-library/hero-background-2-mask';

import './landing-hero-gradient.scss';

export function LandingHeroGradient({
  childrenClassName = '',
  children = null,
  title,
  subTitle = null,
  imageUrl,
  alt = '',
  breadcrumbs = null,
  subTitleClassName = '',
  breadcrumbsClassName = '',
  isMobile = false,
  trackingParent,
  extraContent = null,
}) {
  return (
    <div className={classnames('landing-hero-gradient', { mobile: isMobile })} data-tracking-parent={trackingParent}>
      <ClippedContainer containerClasses="landing-hero-gradient-banner" mask={heroMask}>
        <Container className="px-lg-0">
          {breadcrumbs && (
            <div className={classnames('landing-hero-gradient-breadcrumbs', breadcrumbsClassName)}>{breadcrumbs}</div>
          )}
          <Row className="align-items-center">
            {extraContent && (
              <Col xs={12}>
                <h1 className="text-white size-40 heading-1 fw-bold">{title}</h1>
                {subTitle && <h2 className={classnames('text-white mb-1', subTitleClassName)}>{subTitle}</h2>}
              </Col>
            )}
            <Col xs={12} md={5} className="landing-hero-gradient-heading mb-1_25 mb-md-0">
              {!extraContent && <h1 className="text-white size-40 heading-1 fw-bold">{title}</h1>}
              {!extraContent && subTitle && (
                <h2 className={classnames('text-white mb-0', subTitleClassName)}>{subTitle}</h2>
              )}
              {extraContent && <div className="hidden-md-down">{extraContent}</div>}
            </Col>
            <Col xs={12} md={7}>
              <div className="pos-r p-0_25">
                <ClippedContainer
                  containerClasses="landing-hero-gradient-bg-2 pos-a"
                  mask={isMobile ? heroBackground2MaskMobileChal3 : heroBackground2MaskChal3}
                />
                <ClippedContainer
                  containerClasses="landing-hero-gradient-bg-1 pos-a"
                  mask={isMobile ? heroBackground1MaskMobileChal3 : heroBackground1MaskChal3}
                />
                <ClippedContainer
                  containerClasses="landing-hero-gradient-image-container"
                  mask={isMobile ? heroImageMaskMobileChal3 : heroImageMaskChal3}
                >
                  <img
                    className="w-100 h-100"
                    src={getImageUrl(imageUrl, undefined, SOURCES.STATIC)}
                    alt={alt}
                    fetchPriority="high"
                    decoding="async"
                  />
                </ClippedContainer>
              </div>
              {extraContent && <div className="hidden-md-up">{extraContent}</div>}
            </Col>
          </Row>
        </Container>
      </ClippedContainer>
      <div className={classnames('landing-hero-gradient-children', childrenClassName)}>{children}</div>
    </div>
  );
}

LandingHeroGradient.propTypes = {
  title: PropTypes.node.isRequired,
  alt: PropTypes.string,
  subTitle: PropTypes.node,
  breadcrumbs: PropTypes.node,
  imageUrl: PropTypes.string,
  children: PropTypes.node,
  breadcrumbsClassName: PropTypes.string,
  childrenClassName: PropTypes.string,
  subTitleClassName: PropTypes.string,
  isMobile: PropTypes.bool,
  trackingParent: PropTypes.string,
  extraContent: PropTypes.node,
};
